const MeasureStepThree = () => {
  return <div></div>;
};

export default MeasureStepThree;
